module.exports = __webpack_public_path__ + "media/images/mobile-only/center-7e76154eb3345d94ec968275cfd067e1.png";